import { Loader2 } from "lucide-react";
import type React from "react";
import { useTranslation } from "react-i18next";

/** Full-screen Suspense fallback, used where the shape of the incoming content is unknown. */
export const Loading: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div aria-live="polite" aria-busy className="fixed inset-0 z-50 flex items-center justify-center bg-bg-overlay">
      <span className="sr-only">{t("ui.loading")}</span>
      <Loader2 aria-hidden className="size-10 animate-spin text-white" />
    </div>
  );
};
